import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=b584d51c"
import script from "./VendorDetails.vue?vue&type=script&lang=js"
export * from "./VendorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports